﻿export default class SiteStore {

	static loadContent = {};

}
